function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const patchStoragePropertyByType = (storage, type, property, reports, callback)=>{
    const descriptor = Object.getOwnPropertyDescriptor(storage.constructor.prototype, property);
    if (descriptor && descriptor.configurable) {
        Object.defineProperty(storage.constructor.prototype, property, _object_spread_props(_object_spread({}, descriptor), {
            value (...params) {
                var _descriptor_value;
                (_descriptor_value = descriptor.value) === null || _descriptor_value === void 0 ? void 0 : _descriptor_value.call(this, ...params);
                if (this === storage) {
                    callback(...params);
                }
            }
        }));
    } else {
        reports.warning(`Cannot patch storage, descriptor is not configurable`, {
            project: 'sail_core',
            extras: {
                type,
                property
            }
        });
    }
};
export default function patchBrowserStorage(type, notifier, reports) {
    if (typeof globalThis !== 'undefined' && typeof globalThis[type] === 'object') {
        const storage = globalThis[type];
        if (!(storage === null || storage === void 0 ? void 0 : storage.constructor)) {
            reports.warning(`Cannot patch storage`, {
                project: 'sail_core',
                extras: {
                    type
                }
            });
            return;
        }
        patchStoragePropertyByType(storage, type, 'setItem', reports, (key, value)=>{
            notifier({
                type: 'set',
                key,
                value
            });
        });
        patchStoragePropertyByType(storage, type, 'removeItem', reports, (key)=>{
            notifier({
                type: 'remove',
                key
            });
        });
        patchStoragePropertyByType(storage, type, 'clear', reports, ()=>{
            notifier({
                type: 'clear'
            });
        });
    }
}

//# sourceMappingURL=patchBrowserStorage.js.map